import options from './component';


export default {
    selector: "dtEmulatorEthernetStatus",
    options
}